import { Box, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import NavMenu from '../components/NavMenu';
import Footer from '../components/ui/Footer';

const NotFound = () => {
  return (
    <>
      <NavMenu />
      <Box sx={{ textAlign: 'center', marginTop: '4rem' }}>
        <Typography variant="h4">Page Not Found.</Typography>
        <NavLink
          to="/"
          style={{
            color: '#544f42',
            textDecoration: 'none',
          }}
        >
          <Typography variant="h6">
            Click here to be redirected to the home page.
          </Typography>
        </NavLink>
      </Box>
      <Footer />
    </>
  );
};

export default NotFound;
